/** Simple djb2-style string hash for cache keys. No external dependency. */
export function hashString(str: string): string {
  let hash = 5381
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33 + str.charCodeAt(i)) >>> 0
  }
  return hash.toString(36)
}
